/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getAddressDecoder,
  getAddressEncoder,
  getStructDecoder,
  getStructEncoder,
  type Address,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
} from '@solana/kit';

export type SetAuthorityArgs = { adminAuthority: Address };

export type SetAuthorityArgsArgs = SetAuthorityArgs;

export function getSetAuthorityArgsEncoder(): FixedSizeEncoder<SetAuthorityArgsArgs> {
  return getStructEncoder([['adminAuthority', getAddressEncoder()]]);
}

export function getSetAuthorityArgsDecoder(): FixedSizeDecoder<SetAuthorityArgs> {
  return getStructDecoder([['adminAuthority', getAddressDecoder()]]);
}

export function getSetAuthorityArgsCodec(): FixedSizeCodec<
  SetAuthorityArgsArgs,
  SetAuthorityArgs
> {
  return combineCodec(
    getSetAuthorityArgsEncoder(),
    getSetAuthorityArgsDecoder(),
  );
}
